// extracted by mini-css-extract-plugin
export default {"header":"Header_header__1VCKf","title":"Header_title__3SH2Q","popover":"Header_popover__1kQZa","actions":"Header_actions__2XXqy"};